import React from 'react';
import PropTypes from 'prop-types';

const IconStarStroke = ({ fill, className, width, height }) => (
    <svg
        className={`apc-svg-icon ${className}`}
        viewBox="0 0 50 50"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
    >
        <path
            d="M3 19.664c0-.669.482-1.084 1.447-1.247L17.42 16.44l5.815-12.328C23.56 3.37 23.984 3 24.5 3c.517 0 .939.37 1.266 1.11l5.815 12.33 12.972 1.977c.965.163 1.447.578 1.447 1.247 0 .379-.215.812-.646 1.3l-9.406 9.592 2.222 13.547c.035.253.052.434.052.542 0 .38-.09.7-.272.962-.18.262-.452.393-.814.393-.31 0-.654-.108-1.033-.325L24.5 39.28l-11.603 6.395c-.362.217-.706.325-1.033.325-.345 0-.608-.131-.789-.393-.18-.262-.27-.582-.27-.962 0-.235.008-.415.025-.542l2.222-13.547-9.38-9.592c-.448-.47-.672-.903-.672-1.3z"
            fill="none"
            stroke={fill}
            strokeWidth={3}
        />
    </svg>
);

IconStarStroke.propTypes = {
    fill: PropTypes.string,
    className: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
};

IconStarStroke.defaultProps = {
    fill: '#ffffff',
    className: '',
    width: 20,
    height: 20,
};

export default IconStarStroke;
